import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"

const initialState = {
  itemStatus: "idle",
  itemInfo: null,
  itemError: null,
}

export const updateItem = createAsyncThunk(
  "update/updateItem",
  async ({token,values,id}, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `/api/product/edit/${id}`,values,
        {
        headers: {
                Authorization: `Bearer ${token}`,
            },
        }
      )
      return data
    } catch (err) {
      return rejectWithValue(err.response.data)
    }
  }
)
export const updateitemSlice = createSlice({
  name: "update",
  initialState,
  reducers: {
    resetItem(state,action){
        state.itemInfo = null
        state.itemStatus="idle"
        state.itemError = null
      }
  },
  extraReducers: {
    [updateItem.pending]: (state, action) => {
      state.itemStatus = "loading"
    },
    [updateItem.fulfilled]: (state, action) => {
      state.itemStatus = "succeeded"
      state.itemInfo = action.payload.product
    },
    [updateItem.rejected]: (state, action) => {
      state.itemStatus = "failed";
      state.itemError = action.payload
    },
  },
})

export const { resetItem } = updateitemSlice.actions
export default updateitemSlice.reducer 